import { useQuery } from "react-query";
import CurrentUser from "../apiResources/CurrentUser";
import Employer from "../apiResources/Employer";
import EmployerUser from "../apiResources/EmployerUser";
import Recruiter from "../apiResources/Recruiter";
import RecruiterUser from "../apiResources/RecruiterUser";

export const fetchUserWithCompany = async () => {
  const currentUser = (await CurrentUser.first()).data as CurrentUser;

  let user: Partial<RecruiterUser> | Partial<EmployerUser>;
  let company: Partial<Recruiter> | Partial<Employer>;

  if (currentUser.isRecruiter) {
    user = (await RecruiterUser.find(currentUser.id)).data.attributes;
    company = (await Recruiter.find(user.companyId)).data.attributes;
  } else if (currentUser.isEmployer) {
    user = (await EmployerUser.find(currentUser.id)).data.attributes;
    company = (await Employer.find(user.companyId)).data.attributes;
  }

  company.id = String(user.companyId);

  const data = {
    ...currentUser,
    ...user,
    company,
  };

  return data;
};

export const updateEmployerUser = async (
  fields: EmployerUser["attributes"]
) => {
  const { id, ...others } = fields;

  const user = new EmployerUser({ id });
  user.isPersisted = true;
  user.assignAttributes(others);

  const success = user.save();

  return {
    attributes: user.attributes,
    validationErrors: success ? null : user.errors,
  };
};

export const useCurrentUser = () => {
  return useQuery(
    ["currentUser"],
    async () => (await CurrentUser.first()).data,
    {
      refetchOnWindowFocus: false,
    }
  );
};

export const useRecruiterUser = () => {
  const { data: user } = useCurrentUser();

  const userId = user?.id;

  return useQuery(
    ["recruiter", userId],
    async () => (await RecruiterUser.find(userId)).data,
    {
      enabled: !!userId,
      refetchOnWindowFocus: false,
    }
  );
};
